<template>
    <div class="rankWorkP">
        <rankWorkWeb ></rankWorkWeb>
    </div>
</template>
<style type="text/css">

</style>
<script>
    import rankWorkWeb from "../components/rankWork/rankWorkWeb.vue"
    export default{
        data(){
            return {
                pageHeight:"600px",
                rankWeb:false
            };
        },
        components: {
            rankWorkWeb
        },
        created(){
             this.$nextTick(() => {
              this.OnLoad();
           })
        },
        methods:{
            OnLoad(){
                  if(!this.$route.path.indexOf("/api")){
                    this.rankWeb=false;
                 } else{
                    this.rankWeb=true;
                 }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// rankWork.vue?e998e89e